/**
 * Builds an updateDoc() fragment that flips a request's status AND records when
 * it happened — both as a scalar (statusChangedAt = last change) and in a
 * per-status map (statusTimestamps.<STATUS>) that powers the waitlist timeline.
 *
 * The dotted key merges into the map without clobbering earlier stamps.
 * Firestore rules allow status, statusChangedAt and statusTimestamps on the
 * counterpart status-only path, so this is safe for cross-party writes too.
 *
 * Usage:
 *   await updateDoc(ref, statusStamp("IN_PROGRESS"));
 *   await updateDoc(ref, { ...statusStamp("CANCELLED", ts), cancelledAt: ts });
 */
export function statusStamp(status, ts = new Date().toISOString()) {
  return {
    status,
    statusChangedAt: ts,
    [`statusTimestamps.${status}`]: ts,
  };
}
